module.exports = __webpack_public_path__ + "img/gestionar-expertos.33c5575f.png";